import { ArrowUpRightIcon } from "lucide-react";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { Avatar, Button, Rows } from "components/elements";
import { useAllOrganizations } from "hooks/useAllOrganizations";
import { useCurrentUser } from "hooks/useCurrentUser";
import { trpc } from "lib/trpc";
import { CreateDiscussionModal } from "screens/discussions/CreateDiscussionModal";
import { ClientFileReport } from "@compass/shared/types";
import { ClientDocument, DiscussionCreate } from "@compass/shared/types";
import { FullscreenFileModal } from "./FullScreenBenchmarkModal";

export const BenchmarkListTable = ({ benchmark }: { benchmark: ClientFileReport[] }) => {
    const [isCreateDiscussionModalOpen, setCreateDiscussionModalOpen] = useState(false);
    const [selectedUrl, setSelectedUrl] = useState<string | null>(null);
    const currentUser = useCurrentUser();
    const utils = trpc.useContext();
    const { enqueueSnackbar } = useSnackbar();
    const organizationsList = useAllOrganizations(currentUser);
    const createDiscussion = trpc.discussions.create.useMutation();
    const [createDiscussionattachments, setcreateDiscussionattachments] = useState<
        ClientDocument[]
    >([]);

    const handleCreateSubmit = (discussion: DiscussionCreate) => {
        const dataWithAttachments = {
            ...discussion,
            message: {
                ...discussion.message,
                attachments: createDiscussionattachments.map((a) => a.id),
            },
        };

        createDiscussion.mutate(dataWithAttachments, {
            onSuccess: () => {
                enqueueSnackbar("Discussion created successfully", { variant: "success" });
                utils.discussions.list.invalidate();
                setCreateDiscussionModalOpen(false);
            },
        });
    };
    return (
        <Rows>
            <>
                {benchmark.map((benchmarkItem) => (
                    <div
                        className="flex w-full flex-row items-start gap-3 rounded-2xl border border-[#c8c8c8] bg-white py-4 px-3 transition-colors duration-200 ease-in-out"
                        key={`benchmark_${benchmarkItem.id}`}
                    >
                        <Avatar
                            photoUrl={benchmarkItem.author?.avatar}
                            className="h-[50px] w-[50px]"
                            name={benchmarkItem.author?.name}
                        />
                        <div className="flex w-full flex-col gap-1">
                            {/* {benchmarkItem.title && <h2>{benchmarkItem.title}</h2>} */}
                            {benchmarkItem.description && <p>{benchmarkItem.description}</p>}
                            {benchmarkItem.embeddedFiles?.map((embedUrl, index) => (
                                <div
                                    className="mb-4 flex w-full flex-col items-start justify-between gap-3"
                                    key={`benchmark_${benchmarkItem.id}_file_${index}`}
                                >
                                    <iframe
                                        className="h-[530px] w-full rounded border"
                                        src={embedUrl}
                                    ></iframe>

                                    <div className="flex w-full justify-end gap-2">
                                        <FullscreenFileModal
                                            embedUrl={embedUrl}
                                            trigger={
                                                <Button
                                                    className="mt-1"
                                                    variant="primary"
                                                    onClick={() => setSelectedUrl(embedUrl)}
                                                >
                                                    Pop Out
                                                </Button>
                                            }
                                        />
                                        <a
                                            href={embedUrl}
                                            download
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ textDecoration: "none" }}
                                        >
                                            <Button className="mt-1 " variant="secondary">
                                                Open in Google Drive
                                            </Button>
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </>
            {
                <>
                    {currentUser?.role !== "READONLY_USER" && (
                        <div className="mt-6 flex flex-col items-center justify-center gap-2">
                            <span className="text-[#424242]">Have questions or feedback?</span>
                            <Button
                                variant="primary"
                                onClick={() => setCreateDiscussionModalOpen(true)}
                            >
                                Start a discussion now!
                            </Button>
                        </div>
                    )}

                    {currentUser && (
                        <CreateDiscussionModal
                            isOpen={isCreateDiscussionModalOpen}
                            onClose={setCreateDiscussionModalOpen}
                            currentUser={currentUser}
                            onSubmit={handleCreateSubmit}
                            attachments={createDiscussionattachments}
                            setAttachments={setcreateDiscussionattachments}
                            organizations={organizationsList?.data ?? []}
                        />
                    )}
                </>
            }
        </Rows>
    );
};
